import React, { useState, useContext, useRef } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import getinvoiceaction from "../../context/action/sell/getinvoiceaction";
import Sellinvoicedetailmodal from "../sell/sellinvoicedetailmodal";
// import '../sell/sellinvoiceprint.scss';
import {Sellitemprint} from "../sell/sellitemprint";
import money_rounding from "../../utils/money_rounding";
import moment from "moment/moment";

const Sellinvoicelist = () => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);
    const [show, setshow] = useState(false);
    const [invoice_detail, setinvoice_detail] = useState([]);
    const [invoice_detailprint, setinvoice_detailprint] = useState([]);
    const [from, setfrom] = useState();
    const [to, setto] = useState();
    const [invoice_id, setinvoice_id] = useState();
    const [item_barcode, setitem_barcode] = useState();
    const [error, seterror] = useState(false);
    const [error1, seterror1] = useState(false);
    const [invoiceno, setinvoiceno] = useState(0);

    const [sell_invoice_type, setsell_invoice_type] = useState();
    const [sell_invoice_discount, setsell_invoice_discount] = useState();
    const [sell_invoice_dollar_price, setsell_invoice_dollar_price] = useState();
    const [customer_name, setcustomer_name] = useState();
    const [customer_address, setcustomer_address] = useState();
    const [customer_phone, setcustomer_phone] = useState();
    const [itms, setitms] = useState([]);



    // const printRef = useRef();
    
    // const printFn = useReactToPrint({
    //     contentRef: printRef,
    //     documentTitle: "AwesomeFileName"
    // });
  const printit=(invoiceno)=>{
    setinvoiceno(invoiceno);
    setTimeout(() => {
      window.print();
    }, 1500);
  }
  return (
    <div>
      {/* <div style={{display:'none'}}>
          <Sellitemprint ref={printRef} invoiceno={invoiceno} sell_invoice_type={sell_invoice_type} sell_invoice_discount={sell_invoice_discount} sell_invoice_dollar_price={sell_invoice_dollar_price} customer_name={customer_name} customer_address={customer_address} customer_phone={customer_phone} items={items} />
      </div> */}
      {/* <Sellitemprint username={initState.token.username} items={invoice_detailprint} invoiceno={invoiceno}/> */}
      <div className="min-h-screen bg-slate-50 p-6 md:p-8">
        <Sellinvoicedetailmodal 
          show={show}
          setshow={setshow}
          invoice_detail={invoice_detail}
          setinvoice_detail={setinvoice_detail}
          printit={printit}
        />
        {/* Page Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-2xl font-bold text-slate-800">فرۆشراو</h1>
            <p className="text-sm text-slate-400 mt-0.5">لیستی وەسڵی فرۆشراو</p>
          </div>
        </div>

        <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 items-end">
          <div className="w-full">
            <label
              className={
                error
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }
              htmlFor="from_date"
            >
              لە بەرواری{" "}
            </label>
            <input
              className={
                error
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              id="from_date"
              type="date"
              value={from}
              onChange={(val) => setfrom(val.target.value)}
              onFocus={() => seterror(false)}
            />
          </div>
          <div className="w-full">
            <label
              className={
                error1
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
              }
              htmlFor="to_date"
            >
              بۆ بەرواری{" "}
            </label>
            <input
              className={
                error1
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              }
              id="to_date"
              type="date"
              value={to}
              onChange={(val) => setto(val.target.value)}
              onFocus={() => seterror1(false)}
            />
          </div>
          <div className="w-full">
              <label
                className={
                  "block text-sm font-medium text-slate-500 mb-1 text-right"
                }
                htmlFor="invoice_id"
              >
                ژمارەی پسوڵە
              </label>
              <input
                className={
                  "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                }
                id="invoice_id"
                type="number"
                placeholder=""
                onClick={(val)=>{val.target.select()}}
                value={invoice_id}
                onChange={(val) => setinvoice_id(val.target.value)}
              />
          </div>
          <div className="w-full">
              <label
                className={
                  "block text-sm font-medium text-slate-500 mb-1 text-right"
                }
                htmlFor="item_barcode"
              >
                کۆدی کاڵا
              </label>
              <input
                className={
                  "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                }
                id="item_barcode"
                type="text"
                placeholder=""
                onClick={(val)=>{val.target.select()}}
                value={item_barcode}
                onChange={(val) => setitem_barcode(val.target.value)}
              />
          </div>
          <div className="w-full">
            <button
              className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
              onClick={() => {
                if (!from || from == "") {
                  seterror(true);
                  return false;
                }
                if (!to || to == "") {
                  seterror1(true);
                  return false;
                }
                getinvoiceaction(from,to,invoice_id,item_barcode)(recaller)(setrecaller)(initDispatch)(
                  clear
                );
              }}
            >
              گەڕان
            </button>
          </div>
        </div>
        </div>
        {initState.today_invoice.length > 0 ? (
          <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-100">
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  ژمارەی وەسڵ
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  کڕیار
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  جۆری وەسڵ
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  بەروار
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  داشکاندن
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  نرخی دۆلار
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  کۆی نرخی پسوڵە
                </th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                  بڕی واسڵکراو
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {initState.today_invoice.map((lis, index) => (
                <tr
                  key={index}
                  className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer"
                  onClick={() => {
                    var temp_items=lis.items.map((item) => {
                      return {
                        ...item,
                        item_unit_one_qty: (Number(item.item_qty) % item.item_unit_one_of_many),
                        item_unit_many_qty: Math.floor(item.item_qty/ Number(item.item_unit_one_of_many)),
                      }
                    });
                    var temp_invoice_detail = {
                      ...lis,
                      items: temp_items,
                    };
                    setinvoice_detailprint(lis.items);
                    setinvoice_detail(temp_invoice_detail);
                    setshow(true);
                  }}
                >
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {lis.sell_invoice_id}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {lis.sell_invoice_customer_name}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {lis.sell_invoice_type=="loan"?"قەرز":"کاش"}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    {moment(lis.sell_invoice_date).format("YYYY-MM-DD hh:mm A")}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    {numberbeautify(lis.sell_invoice_discount)}%
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {numberbeautify(lis.sell_invoice_dollar_price)}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {numberbeautify(
                        money_rounding(
                        Number(lis.items.reduce((acc, item) => {
                        return acc + (item.item_sell_state=="pay"? (item.item_sell_price * (item.item_qty)):0);
                      }
                      , 0))*(1-lis.sell_invoice_discount/100)))
                      } $
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {
                        lis.sell_invoice_type=="loan"?
                        numberbeautify(money_rounding(lis.sell_invoice_loan_in_amount))+" $":
                        "-"
                      }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
      ) : null}
    </div>
    </div>
  )
}

export default Sellinvoicelist